var React = require('react');

function BrokenImage (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2","key":0}),React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":1}),React.createElement("path",{"d":"M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z","key":2})]);
}

BrokenImage.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BrokenImage;

BrokenImage.default = BrokenImage;
